import RightPopupComponent from "components/RightPopup";

import SelectDate from "components/SelectDate";
import InputPhone from "components/InputPhone";

import './index.less';
import './themes/default.less';
import Avatar from "components/Avatar";

export default class EditInfoDataPopup extends RightPopupComponent {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            info: {},
            tempPhoto: false
        };
    }

    get popupName() {
        return "editEmployeeInfoPopup";
    }

    setInfoState(key, value) {
        this.state.info[key] = value;

        if (key === "roleId" && value === 4) {
            this._helper.showNotifyPopup({ type: "success", label: "", text: this.tr("employee.notifSelectDoctor") });
        }
    }

    changeInfoState(key, value) {
        const info = this.state.info;
        info[key] = value;
        this.setState({ info });
    }

    show(info, hideCb) {

        this.setState({ info });
        this.hidCb = hideCb;
        this.dialogTitle = "employee.titleEditInfoEmployee";

        super.show();
    }

    formUpdateInfo() {
        const { info } = this.state;
        const { status, lname, fname, sname, shortName,
            phoneNumber, workPhone, birthday, email, address, roleId, hireDate, snils } = info;

        return { lname, fname, sname, shortName, status, phoneNumber, workPhone, birthday, email, address, roleId, hireDate, snils };
    }

    async save() {
        const { tempPhoto, info: profile } = this.state;
        const info = this.formUpdateInfo();

        if (this.checkValidate(info)) {
            this.hide();

            if (tempPhoto) {
                const infoFile = {
                    fileInfo: { image: tempPhoto, name: tempPhoto.name },
                };

                this._request.images.uploadEmployeeAvatar(profile.id, infoFile, (error, result) => {
                    if (!error) {
                        const { code, data } = JSON.parse(result);
                        if (code === "success") {
                            if (Array.isArray(data) && data.length > 0) {
                                if (this.hidCb?.apply)
                                    this.hidCb(info);
                            }
                        }
                    } else if (this.hidCb?.apply) {
                        this.hidCb(info);
                    }
                });
            } else if (this.hidCb?.apply) {
                this.hidCb(info);
            }

        }
    }

    checkValidate(info) {

        if (!info.lname) {
            this.showError("client.errorlname");
            this.lnameInput.setFocus();
            return false;
        }

        if (!info.fname) {
            this.showError("client.errorfname");
            this.fnameInput.setFocus();
            return false;
        }

        if (!info.phoneNumber) {
            this.showError("employee.errorPhoneNumber");
            return false;
        }

        if (!info.roleId) {
            this.showError("employee.errorRole");
            return false;
        }


        return true;
    }

    onMode() {
        this.dialogTitle = "client.editingPatientData";
        this.changeState("mode", "edit");
    }


    onChangeDateBirth(value) {
        this.state.info.birthday = value;
    }


    onChangeAvatar(selectedFile) {
        this.changeState("tempPhoto", selectedFile);
    }

    openDialogAvatarUpload(info) {
        this._helper.openDialog("avatarUpload", info, this.onChangeAvatar.bind(this));
    }

    renderButtons() {
        return super.renderButtons();
    }

    onChangeBeginDate(value) {
        this.setInfoState("hireDate", `${value}T02:00:00.000+00:00`);
    }
    getISODate(sdate) {
        if (sdate) {
            let t = sdate.split("T");

            if (t.length === 2) {
                return t[0];
            }
        }

        return this._helper.date.toDateServerStr(new Date());
    }

    renderAvatar() {
        const { info, tempPhoto } = this.state;
        const { photoUid, sex } = info;

        const mode = "edit";

        return (<div className="flex gap16">
            <Avatar
                id={photoUid}
                tempPhoto={tempPhoto ? URL.createObjectURL(tempPhoto) : false}
                sex={sex}
                size={120}
                radius={8}
                iconWidth={120}
                iconHeight={120}
            />
            {mode === "edit" ? <div className="flex between col">
                <div className="buttonIcon">
                    {photoUid ? this.insertButtonIcon({
                        name: "close",
                        tooltip: "main.uploadFile",
                        onClick: null
                    }) : <></>}
                </div>
                <div >
                    {this.insertButton({
                        type: "secondary",
                        size: "small",
                        onClick: this.openDialogAvatarUpload.bind(this, info),
                        label: "client.replacePhoto"
                    })}
                </div>
            </div> : <div>{this.insertButtonIcon({
                name: "edit",
                onClick: this.onMode.bind(this)
            })}</div>}
        </div>);
    }

    renderContent() {
        const { info } = this.state;
        const { employeeStatuses, rolesList } = this._config;
        const { status, lname, fname, sname, shortName,
            phoneNumber, workPhone, birthday, email, address, roleId, hireDate, snils, login } = info;

        const curRoleId = globalThis.appPageView.state?.profile?.roleId || 100;
        const ch_role = [1, 2, 3].includes(curRoleId);


        return (<div className="editEmployeeInfoPopup flex gap16 col" style={{ width: "450px" }}>
            {this.renderAvatar()}
            <div className="inputs flex gap4">
                {this.insertInput({
                    value: lname,
                    itemStyle: "flex1",
                    label: "main.lname",
                    placeHolder: "main.lnamePlace",
                    validator: this._helper.inputValidators.capitalize,
                    onChange: this.setInfoState.bind(this, "lname"),
                    required: true,
                })}
                {this.insertInput({
                    value: fname,
                    itemStyle: "flex1",
                    label: "main.fname",
                    placeHolder: "main.fnamePlace",
                    validator: this._helper.inputValidators.capitalize,
                    onChange: this.setInfoState.bind(this, "fname"),
                    required: true,
                })}
                {this.insertInput({
                    value: sname,
                    itemStyle: "flex1",
                    label: "main.sname",
                    placeHolder: "main.snamePlace",
                    validator: this._helper.inputValidators.capitalize,
                    onChange: this.setInfoState.bind(this, "sname"),
                })}
            </div>

            {<SelectDate currentday={birthday} onClick={this.onChangeDateBirth.bind(this)} />}

            <div className="flex flex1 gap16">
                {this.insertInputTooltip({
                    value: shortName,
                    itemStyle: "flex1",
                    label: "employee.fio_short",
                    tooltip: "employee.fio_short_tooltip",
                    placeHolder: "",
                    onChange: this.setInfoState.bind(this, "shortName"),
                })}
                <InputPhone
                    value={phoneNumber}
                    itemStyle="flex1"
                    label="employee.tel"
                    onChange={this.setInfoState.bind(this, "phoneNumber")}
                    required={true}
                />
            </div>

            <div className="flex flex1 gap16">
                <InputPhone
                    value={workPhone}
                    itemStyle="flex1"
                    label="employee.telWork"
                    onChange={this.setInfoState.bind(this, "workPhone")}

                />
                {this.insertInput({
                    value: email,
                    itemStyle: "flex1",
                    label: "employee.email",
                    placeHolder: "mail@mail.ru",
                    onChange: this.setInfoState.bind(this, "email"),

                })}
            </div>

            <div className="flex flex1 gap16">
                {this.insertInput({
                    ref: el => this.snils = el,
                    itemStyle: "flex1",
                    value: snils,
                    label: "СНИЛC",
                    placeHolder: "000-000-000-00",
                    format: "xxx-xxx-xxx-xx",
                    validator: this._helper.inputValidators.format,
                    onChange: this.setInfoState.bind(this, "snils")
                })}

            </div>

            <div className="inputFull">
                {this.insertInput({
                    value: address,
                    itemStyle: "flex1",
                    label: "employee.portfolio",
                    placeHolder: "employee.examplePortfolio",
                    onChange: this.setInfoState.bind(this, "address")
                })}
            </div>

            {this.insertLine()}
            {this.insertContentTitle("employee.system")}

            <div className="flex flex1 gap16">
                {this.insertInput({
                    value: login,
                    itemStyle: "flex1",
                    label: "employee.login",
                    readonly: true
                })}
            </div>

            <div className="flex flex1 gap8">
                {this.insertSelect({
                    value: roleId,
                    label: "employee.role_system",
                    helpText: "Main tooltip",
                    showLeftIcon: false,
                    placeHolder: "main.notIndicated",
                    translate: true,
                    items: rolesList,
                    onChange: this.setInfoState.bind(this, "roleId"),
                    editable: ch_role
                })}
                {this.insertSelect({
                    value: status,
                    label: "employee.status",
                    showLeftIcon: false,
                    placeHolder: "main.notIndicated",
                    translate: true,
                    items: employeeStatuses,
                    onChange: this.setInfoState.bind(this, "status"),
                })}
                {this.insertInputDate({
                    value: this.getISODate(hireDate),
                    label: "employee.date_start",
                    type: "date",
                    onChange: this.onChangeBeginDate.bind(this),

                })}
            </div>
        </div>
        );
    }
}
